// AdminWaitingPage.tsx — (TF-6b-4; design §4) Admin → Waiting on you: one list of what waits on a person (lib/waiting.ts).
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageContainer } from "@/components/v2/primitives.tsx";
import { apiGet } from "@/api/client.ts";
import { waitingRows, clockRed, NOT_LISTED_YET, type WaitingSources } from "@/lib/waiting.ts";

export function AdminWaitingPage() {
  const [data, setData] = useState<ReturnType<typeof waitingRows> | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    apiGet<WaitingSources>("/admin/waiting").then((s) => setData(waitingRows(s, Date.now())))
      .catch((e) => setErr(String((e as Error)?.message ?? e)));   // catch-reason: shown in place of the list
  }, []);
  return (
    <PageContainer title="Waiting on you" subtitle="Every run, series and slate waiting on a person, and where it is decided.">
      {err && <div style={{ color: "#b91c1c", fontSize: 13 }}>The list couldn't be read: {err}</div>}
      {!data && !err && <div className="tf-muted">Reading…</div>}
      {data?.unreadable.map((u) => <div key={u} style={{ color: "#b91c1c", fontSize: 13, marginBottom: 4 }}>Couldn't be read — {u}</div>)}
      {data?.partial.map((u) => <div key={u} className="tf-muted" style={{ fontSize: 13, marginBottom: 4 }}>{u}</div>)}
      {data && data.rows.length === 0 && <div className="tf-muted">Nothing is waiting on you.</div>}
      {data && data.rows.length > 0 && (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, marginTop: 8 }}>
          <thead><tr style={{ textAlign: "left" }}><th>What</th><th>Since</th><th>Days left</th><th>Decided on</th></tr></thead>
          <tbody>{data.rows.map((r, i) => (
            <tr key={i} style={{ borderTop: "1px solid var(--tf-border, #e5e7eb)" }}>
              <td><Link to={r.link}>{r.what}</Link>{r.detail && <div className="tf-muted" style={{ fontSize: 12 }}>{r.detail}</div>}</td>
              <td>{r.since ? new Date(r.since).toLocaleString() : "—"}</td>
              <td style={clockRed(r.daysLeft) ? { color: "#b91c1c", fontWeight: 600 } : undefined}>{r.daysLeft ?? "—"}</td>
              <td className="tf-muted">{r.decidedOn}</td>
            </tr>))}</tbody>
        </table>)}
      {data?.fallback && <div className="tf-muted" style={{ fontSize: 12, marginTop: 12 }}>{NOT_LISTED_YET}</div>}
    </PageContainer>
  );
}
